import { FormTypeBase } from './form-type-base';
import * as moment from 'moment';

export class FormTypeDate extends FormTypeBase {

    constructor(options: {
        fieldCode?: string,
        key?: string,
        order?: number
    } = {}) {
        options['type'] = 'date';
        super(options);
    }

    transform(val) {
        const mom = moment(val, 'YYYY-MM-DD');
        if (mom.isValid()) {
            return mom.toDate();
        }
        return moment().toDate();
    }
}



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/core/models/form/form-type-date.ts